import Vue from 'vue'
import i18n from './i18n'

// TODO: reemplazar require para utilizar this.$moment.locale(myNewLocale)
const moment = require('moment')
require('moment/locale/es')

// TODO: trasladar Vue.use a main.js
Vue.use(require('vue-moment'), {
  moment
})

let lang = new Vue({
  data () {
    return {
      currentLanguage: i18n.locale,
      // TODO:
      // importar arreglo con valores de lenguajes soportados por UI [{locale, name}]
      // este array servirá para mostrarlo en componente que se utilizará como 'switch de idioma'
      laguages: []
    }
  },

  watch: {
    currentLanguage () {
      document.querySelector('html').setAttribute('lang', this.currentLanguage)
      i18n.locale = this.currentLanguage
      this.setTranlations()
    }
  },

  methods: {
    getCurrentLanguage () {
      return this.currentLanguage
    },

    getLanguages () {
      return this.laguages
    },

    setCurrentLanguage (language) {
      this.currentLanguage = language
    },

    setTranlations () {
      // TODO: cambiar messages de i18n por nuevos valores de translations
    }
  }
})

export default {
  install: (Vue) => {
    Vue.prototype.$lang = lang
  }
}
